import React from 'react'
import { TextField,IconButton, Box } from '@mui/material';
import { FaCheck } from 'react-icons/fa';


function EditableField({ value, label, name, onChangeHandler, handleSave }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        position: 'relative',
      }}
    >
      <TextField
        fullWidth
        label={label}
        name={name}
        value={value}
        onChange={(e) => onChangeHandler(e)}
        margin="dense"
        size="small"
        sx={{ flexGrow: 1, minWidth: 0, pr: 4 }}
        data-cypress-name={`edit-field-${label.toLowerCase().replace(':', '').trim()}`}
      />
      <IconButton
        onClick={handleSave}
        color="success"
        size="small"
        sx={{ position: 'absolute', right: 5 }}
        data-cypress-name={`save-${label.toLowerCase().replace(':', '').trim()}`}
      >
        <FaCheck />
      </IconButton>
    </Box>
  );
}

export default EditableField;